import { MessageCircle } from "lucide-react";
import { SITE } from "@/lib/siteConfig";
import { trackConversion } from "@/lib/gtag";

export default function WhatsAppButton() {
  const message = encodeURIComponent(
    "Bonjour, j'ai besoin d'un serrurier en urgence. Pouvez-vous m'aider ?"
  );
  const href = `${SITE.whatsappHref}?text=${message}`;

  return (
    <a
      href={href}
      onClick={() => trackConversion("whatsapp_click")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      aria-label="Discuter sur WhatsApp"
      className="fixed bottom-5 left-5 lg:bottom-28 z-50 group flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5a] text-white pl-4 pr-5 h-14 rounded-full shadow-2xl transition-all hover:-translate-y-0.5"
    >
      <span className="relative flex items-center justify-center w-9 h-9 rounded-full bg-white/15">
        <span className="absolute inset-0 rounded-full bg-white/40 animate-ping opacity-60" />
        <MessageCircle className="relative w-5 h-5" strokeWidth={2.5} fill="currentColor" />
      </span>
      <span className="hidden sm:flex flex-col leading-tight">
        <span className="text-[10px] uppercase tracking-[0.2em] font-bold opacity-90">
          WhatsApp
        </span>
        <span className="font-display font-black text-sm tracking-tight">
          Écrivez-nous
        </span>
      </span>
    </a>
  );
}
